import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../../Utils/renderField/renderReadField";
import { VaciadosCell } from "../../../components/VaciadosCell";
import NullableValue from "../../../../../Utils/renderField/nullableValue";
const ver_img = require("assets/img/icons/ver.png");

export const RecepcionesTable = ({
    recepciones,
    recepcionesSeleccionadas,
    setRecepcionesSeleccionadas,
}) => {
    return (
        <div className="new-table-wrapper traslado-recepciones__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th>ID RECEPCIÓN</th>
                        <th>FECHA DE RECEPCIÓN</th>
                        <th>LUGAR</th>
                        <th>PLACA VEHICULO</th>
                        <th>FINCA</th>
                        <th>MATERIA PRIMA</th>
                        <th>ALMACENES</th>
                        <th>KILOS HÚMEDOS</th>
                        <th>DRC LABORATORIO</th>
                        <th className="table__min-width-cell">
                            KILOS SECOS LAB
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {recepciones.length === 0 && (
                        <tr>
                            <td colSpan={12} className="text-center">
                                No hay recepciones disponibles.
                            </td>
                        </tr>
                    )}
                    {recepciones.map((item) => {
                        // Se busca por id, aunque los ids de ingreso se repitan los movimientos son distintos.
                        const estaSeleccionada = recepcionesSeleccionadas.some(
                            (itemSeleccionado) =>
                                itemSeleccionado.id === item.id,
                        );

                        return (
                            <tr
                                key={item.id}
                                className={
                                    estaSeleccionada ? "traslado-recepciones__selected-row" : ""
                                }
                            >
                                <td className="text-center">
                                    <div className="table-actions">
                                        <input
                                            type="checkbox"
                                            className="checkbox"
                                            checked={estaSeleccionada}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setRecepcionesSeleccionadas(
                                                        [
                                                            ...recepcionesSeleccionadas,
                                                            item,
                                                        ],
                                                    );
                                                } else {
                                                    const recepcionesFiltradas =
                                                        recepcionesSeleccionadas.filter(
                                                            (
                                                                itemSeleccionado,
                                                            ) =>
                                                                itemSeleccionado.id !==
                                                                item.id,
                                                        );

                                                    setRecepcionesSeleccionadas(
                                                        recepcionesFiltradas,
                                                    );
                                                }
                                            }}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className="table-actions">
                                        <Link
                                            to={`/ingreso/${item.id_ingreso}/`}
                                            className="px-2"
                                        >
                                            <img
                                                src={ver_img}
                                                alt="Ver"
                                                className="action_img"
                                            />
                                        </Link>
                                    </div>
                                </td>
                                <td className="text-center">
                                    {item.id_ingreso}
                                </td>
                                <td className="text-center text-nowrap">
                                    {moment(item.fecha_entrada).format(
                                        "DD/MM/YYYY HH:mm:ss",
                                    )}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.acopio
                                        ? item.acopio.nombre
                                        : "Planta ERSA"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.vehiculo ? item.vehiculo.placa : ""}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.finca ? item.finca.nombre : ""}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.materia_prima
                                        ? item.materia_prima.nombre
                                        : ""}
                                </td>
                                <td className="text-center text-nowrap">
                                    <VaciadosCell productos={item.productos} />
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={item.kilos_humedos}>
                                        <RenderKilogramo
                                            value={item.kilos_humedos}
                                            decimalScale={2}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={item.drc_laboratorio}>
                                        <RenderNumberPercentage
                                            value={item.drc_laboratorio}
                                            decimalScale={3}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.kilos_secos_laboratorio}
                                    >
                                        <RenderKilogramo
                                            value={item.kilos_secos_laboratorio}
                                            decimalScale={3}
                                        />
                                    </NullableValue>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
